
export default () => ({
  app: {
    pages: {
      index: 'Курсы',
      courses: {
        edit: 'Карточка курса',
        create: 'Создать курс',
      },
      users: {
        list: 'Пользователи',
        edit: 'Карточка пользователя',
        create: 'Создать пользователя',
      },
      categories: {
        list: 'Проф. области',
        edit: 'Карточка проф. области',
        create: 'Создать проф. область',
      },
      types: {
        list: 'Типы курсов',
        edit: 'Карточка типа',
        create: 'Создать тип',
      },
      students: {
        list: 'Отзывы студентов',
        edit: 'Карточка отзыва',
        create: 'Создать отзыв',
      },
      banners: {
        list: 'Баннеры',
        edit: 'Карточка баннера',
        create: 'Создать баннер',
      },
      faqs: {
        list: 'Вопросы',
        edit: 'Карточка вопроса',
        create: 'Создать вопрос',
      },
      articles: {
        list: 'Новости',
        edit: 'Карточка новости',
        create: 'Создать новость',
      },
      partners: {
        list: 'Партнеры',
        edit: 'Карточка партнера',
        create: 'Создать партнера',
      },
      teachers: {
        list: 'Тренера',
        edit: 'Карточка тренера',
        create: 'Создать тренера',
      },
      mainPartners: {
        list: 'Стратегические партнеры',
        edit: 'Карточка партнера',
        create: 'Создать партнера',
      },
      certs: {
        list: 'Сертификаты',
        edit: 'Карточка сертификата',
        create: 'Создать сертификат',
      },
      images: {
        list: 'Изображения',
        edit: 'Редактировать изображение',
      },
      accounts: {
        list: 'Покупатели',
      },
      pages: {
        list: 'Страницы',
      },
      pays: {
        list: 'Продажи',
      },
      documents: {
        list: 'Документы',
        edit: 'Карточка документа',
        create: 'Создать документ',
      },
      content: 'Контент сайта',
    },
    
    navigation: {
    
    },
    
    breadcrumbs: {
    
    },
  },
})
